<template>
    <v-row>
        <v-col cols="12">
            <v-card class="pb-8">
            <v-card flat>
                <v-card-title>Price adjustments<v-spacer></v-spacer>
                    <v-btn class="primary ma-2" x-small @click="addHspa(huisPriceAgreements.huis_encrid)">Add price adjustment</v-btn>
                    <btn_audit table="hspa" :encrid="this.huis_encrid" :size=30 tooltip="audit of accommodation - price adjustments" />
                </v-card-title>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                            <td>Stay within</td>
                            <td>Number of nights</td>
                            <td>Adjustment %</td>
                            <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(hspaRecord, i) in huisPriceAgreements.hspaCurrent" :key="i">
                            <td>{{ hspaRecord.hspa_verb }}</td>
                            <td>{{ hspaRecord.hspa_aant_nacht }}</td>
                            <td>
                                <div style="display: grid; grid-template-columns: 40px 100px; gap: 8px; align-items: center;">
                                    <div>{{ hspaRecord.hspa_prijs_aanpas_perc }}%</div>
                                    <div v-if="hspaRecord.hspa_prijs_aanpas_perc < 0">decrease</div>
                                    <div v-else>increase</div>
                                </div>
                            </td>
                            <td> <v-btn text icon @click="rmHspa(hspaRecord.hspa_encrid)"><v-icon
                                    small>mdi-trash-can-outline</v-icon></v-btn></td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-card>
        </v-col>
        <addHspa ref="addHspa" @updateData="updateData"></addHspa>
        <rmHspa ref="rmHspa" @updateData="updateData"></rmHspa>
    </v-row>
</template>

<script>
import btn_audit from "@/components/ui/buttons/btn_audit.vue";
import rmHspa from "@/views/huis/hspa/rmHspa.vue";
import addHspa from "@/views/huis/hspa/addHspa.vue";

export default {
    components:{
        btn_audit,
        rmHspa,
        addHspa,
    },
    props: {
        huis_encrid: {
            type: String,
            required: true
        }
    },
    data() { 
        return {
            loading: true,
            loader: null,
            huisPriceAgreements: {hspaCurrent:[],hspaExpired:[],huis_encrid:''},
        }
    },
    mounted() {
        this.getHuisPriceAgreements();
    },
    created() {
    },
    watch: {
        loader () {
            const l = this.loader
            this[l] = !this[l]
        },
    },
    methods: {
        updateData(){
            this.getHuisPriceAgreements();
        },
        getHuisPriceAgreements() {
                this.$axios.post("ares/json/ares/huis/getHuisPriceAgreements.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisPriceAgreements"
                    },
                    getHuisPriceAgreements: {
                        huis_encrid: this.huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.huisPriceAgreements = res.data.getHuisPriceAgreements;
                        this.loading = false;
                    }
                });
        },
        addHspa(huis_encrid) {
            this.$refs.addHspa.open(huis_encrid);
        },
        rmHspa(hsab_encrid) {
            this.$refs.rmHspa.open(hsab_encrid);
        },
    },
}
</script>